import React, { useEffect } from 'react'

export const Stories: React.FC = () => {
  useEffect(() => {
    // @ts-ignore
    if (window?.DiapoInitScript9378d81a316ae998f981c39edb5299ed) window.DiapoInitScript9378d81a316ae998f981c39edb5299ed()
  }, [])

  return <div className="diapo_stories diapo_stories_9378d81a316ae998f981c39edb5299ed" />
}

export default Stories
